import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Http } from '@angular/http';
import { AuthService } from '../../auth/auth.service';
import { Observable, Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';//debug
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import * as moment from 'moment'
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class UtilService {

  private notify = new Subject<any>();
  notifyObservable$ = this.notify.asObservable();
  environment = environment;
  constructor(
    private sanitizer: DomSanitizer,
  ) {
  }

  cleanArray(actual) {
    var newArray = new Array();
    for (var i = 0; i < actual.length; i++) {
      if (actual[i]) {
        newArray.push(actual[i]);
      }
    }
    return newArray;
  }

  isNil = (value: any): value is (null | undefined) => {
    return value === null || typeof (value) === 'undefined';
  };

  isObject = (value: any): boolean => {
    return value && value.constructor === Object;
  };

  isBlank = (value: any): boolean => {
    return this.isNil(value) ||
      (this.isObject(value) && Object.keys(value).length === 0) ||
      value.toString().trim() === '';
  };

  isPresent = (value: any): boolean => {
    return !this.isBlank(value);
  };

  getQueryStringValue (key) {
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
  }


    // method to download base64 file into XLSX
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    }
  
    saveByteArray(reportName, byte) {
      var blob = new Blob([byte]);
      var link = document.createElement('a');
  
      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, reportName);
        return;
      }
      else if (window.navigator.msSaveBlob) { // for IE browser
        window.navigator.msSaveBlob(blob, reportName);
        return;
      }
  
  
      document.body.appendChild(link);
      link.href = window.URL.createObjectURL(blob);
      // window.open(link.href, "_blank");
      // window.open(window.URL.createObjectURL(blob));
      // var fileName = reportName + ".xlsx";
      //console.log(' === blob ========', blob);
      //console.log(' === url ========', link.href);
      var fileName = reportName;
      link.download = fileName;
      link.click();
    };
    
  hasDuplicates(array, key?) {
    var valuesSoFar = Object.create(null);
    for (var i = 0; i < array.length; ++i) {
      var value = array[i][key];
      if (value) {
        if (value in valuesSoFar) {
          return true;
        }
        valuesSoFar[value] = true;
      } else {
        return false;
      }
    }
    return false;
  }

  parseDate(data, listType, keys) {
    if (data) {
      if (data[listType] && data[listType].length) {
        data[listType].forEach(season => {
          if (keys && keys.length) {
            keys.forEach(key => {
              if (season[key]) {
                season[key] = season[key].formatted ? season[key].formatted : season[key];
              }
            })
          }
        })
        return data;
      }
    }
  }

  dateFormatter(data, dateArr) {
    dateArr.forEach(element => {
      if (typeof (data[element]) == 'object') {
        data[element] = data[element].toLocaleDateString();
      }
    });
    return data;
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }

    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }


  dateRangeOverlaps(a_start, a_end, b_start, b_end) {
    if (a_start <= b_start && b_start <= a_end) return true; // b starts in a
    if (a_start <= b_end && b_end <= a_end) return true; // b ends in a
    if (b_start < a_start && a_end < b_end) return true; // a in b
    return false;
  }

  dateFormat(date, momentFormat): string {
    if (date === null) {
      return '';
    }
    let d = moment(date);
    return d.isValid() ? d.format(momentFormat) : '';
  }

  getISODateStrings(date) {

    if(!date){
      return null;
    }

    if(typeof(date) == 'string'){
      return date;
    }else{
      return date.toISOString();
    }

  }

  getISODateString(date) {

    if(!date){
      return null;
    }

    if(typeof(date) == 'string'){
      return date;
    }

    let year = date.getFullYear();

    let utcOffset = this.convertMinutesToHours(Number(date.getTimezoneOffset()));

    let userTime = String(new Date().toISOString()).split('T')[1];
  
    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
  
    let day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

   // return year +  '-' + month + '-' + day + "T00:00:00.000"+utcOffset;

   return year +  '-' + month + '-' + day + 'T' + userTime;
    
    //return month + '/' + day + '/' + year;
  }

  convertMinutesToHours(totalMinutes) {

    let strHours;
    let strMinutes;
    
    let numTotalMinutes = -totalMinutes;
    let hours = (numTotalMinutes / 60);
    let rhours = Math.floor(hours);
    
    if(rhours < 0 && rhours > -10 ) {
      strHours = "-0" + String(-rhours);
    }else if(rhours < 10 && rhours >= 0){
      strHours = "+0" + String(rhours);
    }else{
      strHours = String(rhours);
    }

    let minutes = (hours - rhours) * 60;
    let rminutes = Math.round(minutes);
    
    if(rminutes < 10){
      strMinutes = "0" + String(rminutes);
    }else{
      strMinutes = String(rminutes);
    }

    return strHours + ":" + strMinutes;
  }

  public handleError(error: HttpErrorResponse) {
    if (error.status === 401) {
      return Observable.throw({
        error: 1,
        message: 'Unauthorized',
        responseObj: null
      });
    }
    else if (error.status === 406) {
      return Observable.throw({
        error: 1,
        message: 'Invalid credentials',
        responseObj: null
      });
    }
    else if (error.status === 404) {
      return Observable.throw({
        error: 1,
        message: 'Not found',
        responseObj: null
      });
    }
    else if (error.status === 500) {
      return Observable.throw(error.error);
    }
    else {
      return Observable.throw(error.error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/_services/util.service.ts